import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { RatingStarComponent } from '../icons/rating-star/rating-star.component';

@Component({
    selector: 'lib-rating-stars',
    standalone: true,
    imports: [CommonModule, RatingStarComponent],
    templateUrl: './rating-stars.component.html',
    styleUrl: './rating-stars.component.css'
})
export class RatingStarsComponent {
    @Input() displayTotalRatingsCount: boolean = true;
    @Input() displayRatingAmount: boolean = true;
    @Input() starDisplay: 'single' | 'rating' = 'rating';
    @Input() rating: number = 0;
    @Input() totalRatings: number | null = null;
    @Input() inline: boolean = false;
    @Input() center: boolean = false;
    @Input() ratingTextSize: 'default' | 'large' = 'default';
    @Input() starSize: number | undefined = 16;
    @Input() totalRatingsWithBrackets: boolean = false;
}
